import { z } from 'zod'
import { AuthSessionPrincipalUserSchema } from './auth-session-principal-user.ts'

export const AuthSessionPrincipalSchema = z.object({
  user: AuthSessionPrincipalUserSchema,
  scopes: z.array(z.string()),
})

export type AuthSessionPrincipal = z.infer<typeof AuthSessionPrincipalSchema>
